import { formatDollars } from '../formatting';
import useDiscountPrice from './useDiscountPrice';
export default function useDeviationSaleDetails(deviation) {
    var _deviation_adoptable_fixedPrice, _deviation_adoptable, _eligibleDiscount_amount;
    let eligibleDiscount, notEligibleDiscounts;
    if (deviation === null || deviation === void 0 ? void 0 : deviation.isAdoptable) {
        var _deviation_extended_saleDetails, _deviation_extended;
        ({ eligibleDiscount, notEligibleDiscounts } = (deviation === null || deviation === void 0 ? void 0 : (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_saleDetails = _deviation_extended.saleDetails) === null || _deviation_extended_saleDetails === void 0 ? void 0 : _deviation_extended_saleDetails.adoptableFixed) || {});
    } else if (deviation === null || deviation === void 0 ? void 0 : deviation.pcp) {
        var _deviation_extended_saleDetails1, _deviation_extended1;
        ({ eligibleDiscount, notEligibleDiscounts } = (deviation === null || deviation === void 0 ? void 0 : (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_saleDetails1 = _deviation_extended1.saleDetails) === null || _deviation_extended_saleDetails1 === void 0 ? void 0 : _deviation_extended_saleDetails1.pcp) || {});
    }
    const { price: dollarAmount, discountedPrice: dollarAmountAfterDiscount } = useDiscountPrice(deviation === null || deviation === void 0 ? void 0 : (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : (_deviation_adoptable_fixedPrice = _deviation_adoptable.fixedPrice) === null || _deviation_adoptable_fixedPrice === void 0 ? void 0 : _deviation_adoptable_fixedPrice.fixedPrice, eligibleDiscount);
    const formattedDollarAmount = formatDollars(dollarAmount);
    const formattedDollarAmountAfterDiscount = formatDollars(dollarAmountAfterDiscount);
    const eligibleDiscountDollarAmount = eligibleDiscount === null || eligibleDiscount === void 0 ? void 0 : (_eligibleDiscount_amount = eligibleDiscount.amount) === null || _eligibleDiscount_amount === void 0 ? void 0 : _eligibleDiscount_amount.usd;
    const formattedEligibleDiscountDollarAmount = formatDollars(eligibleDiscountDollarAmount);
    return {
        dollarAmount,
        formattedDollarAmount,
        dollarAmountAfterDiscount,
        formattedDollarAmountAfterDiscount,
        eligibleDiscountDollarAmount,
        formattedEligibleDiscountDollarAmount,
        eligibleDiscount,
        notEligibleDiscounts,
        allDiscounts: [
            ...notEligibleDiscounts || [],
            eligibleDiscount
        ].filter(Boolean),
        isDiscountApplied: !!eligibleDiscount
    };
}

//# sourceMappingURL=useDeviationSaleDetails.js.map